"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterComponent = void 0;
const base_component_1 = require("../../components/base-component");
const utils_1 = require("../../utils/utils");
const FORM_SELECTOR = '[data-register-form]';
class RegisterComponent extends base_component_1.BaseComponent {
    mountComponent() {
        const form = (0, utils_1.$el)(FORM_SELECTOR, this);
        this.addListener(form, 'submit', this.handleSubmit);
    }
    handleSubmit() {
        localStorage.setItem('isRegistered', 'true');
    }
}
exports.RegisterComponent = RegisterComponent;
